import {useState, useCallback} from 'react';
import {declensions} from '../constants/constants' 
import React from 'react'; 

export const AutoComplete = (props) => {
    function handleAutoText() {
      props.onClick(props.item)
    }
    return (
      <>
      {
        props.name === 'search-brands' ?
        <p className='add-recipe__autocomplete_text' onClick={handleAutoText}>{props.item.nameRu}</p>
        :  <p className='add-recipe__autocomplete_text' onClick={handleAutoText}>{props.item.name} {props.item.trait}</p>
      }
      </>
     
    )
  }

  
  export const hasLatinLetters = (str) => {
    if (!str) return false;
    return /[a-zA-Z]/.test(str);
  };
  
  // Функция для транслитерации русских букв в латиницу (опционально)
  export const transliterate = (str) => {
    const ruToEn = {
      // Строчные буквы
    'q': 'й', 'w': 'ц', 'e': 'у', 'r': 'к', 't': 'е', 'y': 'н', 'u': 'г',
    'i': 'ш', 'o': 'щ', 'p': 'з', '[': 'х', ']': 'ъ', 'a': 'ф', 's': 'ы',
    'd': 'в', 'f': 'а', 'g': 'п', 'h': 'р', 'j': 'о', 'k': 'л', 'l': 'д',
    ';': 'ж', "'": 'э', 'z': 'я', 'x': 'ч', 'c': 'с', 'v': 'м', 'b': 'и',
    'n': 'т', 'm': 'ь', ',': 'б', '.': 'ю', '/': '.',
    
    // Заглавные буквы
    'Q': 'Й', 'W': 'Ц', 'E': 'У', 'R': 'К', 'T': 'Е', 'Y': 'Н', 'U': 'Г',
    'I': 'Ш', 'O': 'Щ', 'P': 'З', '{': 'Х', '}': 'Ъ', 'A': 'Ф', 'S': 'Ы',
    'D': 'В', 'F': 'А', 'G': 'П', 'H': 'Р', 'J': 'О', 'K': 'Л', 'L': 'Д',
    ':': 'Ж', '"': 'Э', 'Z': 'Я', 'X': 'Ч', 'C': 'С', 'V': 'М', 'B': 'И',
    'N': 'Т', 'M': 'Ь', '<': 'Б', '>': 'Ю', '?': ','
    };
    
    return str.split('').map(char => ruToEn[char] || char).join('');
  };
 
//Фильтр по поисковому слову в объекте
export function filtrSearchArr(arr, keyword, name) {
  const keywordSearch = keyword.toLowerCase();
  const NewArray = arr.filter((item) => {
    if(name === 'search-brands') {
      return item.nameRu.toLowerCase().includes(keywordSearch)
    } else {
      return item.name.toLowerCase().includes(keywordSearch)
    }
   
  })
  return NewArray
}

export const Cals = (props) => {
  return (
  <li className={`cals_block cals_block__${props.type}`}> 
    <p className={`cals_block_num ${props.type === 'menu' ? 'font12Norm' : 'font14Norm'} `}>{props.name} {props.num} {props.measure}</p>

  </li>
  )
}

  //Преобразование даты в формат дд.мм.гг
  export const dateNorm = (dates) => {
    const date = new Date(dates); 
    // Получаем день, месяц и год
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Месяцы идут с 0
    const year = date.getUTCFullYear();
    
    // Форматируем дату в нужный формат
    return  `${day}.${month}.${year}`;
   }

   export const findDeclension = (number, word) => {
    const declension = declensions.find(item => item.ncase === word); 
    let n = Math.abs(number);
   
    n %= 100;
    if (n >= 5 && n <= 20) {
      return declension.gcasemulti;
    }
    n %= 10;
    if (n === 1) {
      return declension.ncase;
    }
    if (n >= 2 && n <= 4) {
      return declension.gcase;
    }
    return declension.gcasemulti; 
    }

export const priceDish = (ingredient, ingredients) => { 
  let total = ingredient.reduce(function (acc, item) { 
    const ingBase = ingredients.find(i=> i._id ===item._id) // находим по id нужный ингредиент
    if (!ingBase || !ingBase.price) {
      return 0;
    } 
    const isSameMeasure = item.choisMeasure === ingBase.mainMeasure;
    const measurePrice = ingBase.price.measureprice;
    
    let rightWeight = item.weight;
    if (!isSameMeasure) {
      const searchWeight = ingBase.measure.find(i => i.nameRu === item.choisMeasure);
      if (searchWeight) {
        rightWeight = searchWeight.ratio * item.weight;
      }
    }
    
    // Получаем коэффициент для правильного перевода цены
    const rightPriceRatio = ingBase.measure.find(i => i.nameRu === measurePrice)?.ratio || 1;
    const adjustedRate = ingBase.price.rate / (ingBase.price.weightprice * rightPriceRatio);
    
    // Рассчитываем цену
    const price = adjustedRate * rightWeight;
    
    return acc + Number(price);
  },0);
  return total
} 

 //Группировка ингредиентов по группам приготовления
 export function groupedIngredient(data) {
  const result = data.reduce((acc, item) => {
    const group = item.group
    // Если группы еще нет, создаем ее
    if (!acc[group]) {
      acc[group] = [];
    }
    // Добавляем текущий ингредиент в соответствующую группу
    acc[group].push(item);
    return acc;
  }, {});
  return result
}
 //Группировка ингредиентов по категориям
export function catIngredient(data) {
  const result = data.reduce((acc, item) => {
    const group = item.category
    // Если группы еще нет, создаем ее
    if (!acc[group]) {
      acc[group] = [];
    }
    // Добавляем текущий ингредиент в соответствующую группу
    acc[group].push(item);
    return acc;
  }, {});
  return result
}

 //Обработка ошибки введенных ингредиентов
 /*export const useFormErrors = () => {
  const [error, setError] = useState({});

  const validate = (name, value, index, checked) => { 
    let newErrors = { ...error}; // Копируем текущие ошибки 
    switch (name) {
      case 'name':
      case 'ingredients':
        if (value.length === 0) {
          newErrors.ingredients = 'Поле не может быть пустым';
        } else {
          const re = /^[А-Яа-я]/;
          newErrors.ingredients = re.test(String(value).toLowerCase()) ? '' : 'Введите название кириллицей';
        }
        break;

      case 'totalWeight':
        if (value.length === 0) {
          newErrors.totalWeight = 'Поле не может быть пустым';
        } else if (value > 1000) {
          newErrors.totalWeight = 'max = 1000г, выберите меру в кг';
        } else if (value === 0 ) {
          newErrors.totalWeight = 'Значение не может быть равно 0';
        }  else if (value < 0 ) {
          newErrors.totalWeight = 'Значение не может быть меньше 0';
        } else {
          newErrors.totalWeight = '';
        }
        break;

      case 'step1':
        if (value.length === 0) {
          newErrors.step1 = 'Заполните хотя бы 1 шаг приготовления';
        } else if (value.length > 5000) {
          newErrors.step1 = 'Максимальное значение 5000 знаков, Перенесите описание на след шаг';
        } else {
          const re = /^[А-Яа-я]/;
          newErrors.step1 = re.test(String(value).toLowerCase()) ? '' : 'Введите описание кириллицей';
        }
        break;

      case 'advice':
        if (value.length > 5000) {
          newErrors.advice = 'Максимальное значение 5000 знаков';
        } else {
          const re = /^[А-Яа-я]/;
          newErrors.advice = re.test(String(value).toLowerCase()) ? '' : 'Введите описание кириллицей';
        }
        break;

        case `weight${index}`:
        if (value < 0) { 
          newErrors[`weight${index}`] = 'Значение не может быть меньше 0'
        } else if (value === 0 ) {
          newErrors[`weight${index}`] = 'Значение не может быть равно 0';
        } else {
          newErrors[`weight${index}`] = ''
        } 
        break;
        case `step${index+1}`:
          if (value.length === 0) { 
            newErrors.step1 = 'Заполните хотя бы 1 шаг приготовления'
          } else if (value.length > 1000 ) {
            newErrors[`step${index+1}`] = 'Максимальное значение 1000 знаков, Перенесите описание на след шаг';
          } else {
            const re = /^[А-Яа-я]/;
            newErrors[`step${index+1}`]  = re.test(String(value).toLowerCase()) ? '' : 'Введите описание кириллицей';
          }
          break;
        case 'soak': case 'pickle': case 'cool': case 'infusion':  case 'freeze':
        if (value < 1) {
          newErrors[name] = 'Укажите время больше 5 мин или  удалите отметку';
        } else {
          newErrors[name]  = '';
        }
        break;
        case 'basic': 
        if (!checked) {
          newErrors[name] = 'Это поле обязательное для заполнения';
        } else if (value === 0 || value < 2) {
            newErrors[name] = 'Укажите время больше 2 мин';
        }  else {
          newErrors[name] = ''; // Очищаем ошибку, если все условия выполнены
        }
          break;
        case 'note':
          if(value === '') { 
            newErrors.note = ('Выберите способ обработки')
          }  else {
            newErrors.note = ('')
          }
        break;
        case 'type':
          newErrors.type = ('')
          
        break;
      default:
        break;
    }
    
    setError(newErrors);
  }; 
  return { error, validate, setError };
};*/
 export const useFormErrors = () => {
  const [error, setError] = React.useState({});

  const validate = (name, value, index, checked) => { 
    let newErrors = { ...error}; // Копируем текущие ошибки 
    switch (name) {
      case 'name':
      case 'ingredients':
        if (value.length === 0) {
          newErrors.ingredients = 'Поле не может быть пустым';
        } else {
          const re = /^[А-Яа-я]/;
          newErrors.ingredients = re.test(String(value).toLowerCase()) ? '' : 'Введите название кириллицей';
        }
        break;

      case 'totalWeight':
        if (value.length === 0) {
          newErrors.totalWeight = 'Поле не может быть пустым';
        } else if (value > 1000) {
          newErrors.totalWeight = 'max = 1000г, выберите меру в кг';
        } else if (value === 0 ) {
          newErrors.totalWeight = 'Значение не может быть равно 0';
        }  else if (value < 0 ) {
          newErrors.totalWeight = 'Значение не может быть меньше 0';
        } else {
          newErrors.totalWeight = '';
        }
        break;

      case 'step1':
        if (value.length === 0) {
          newErrors.step1 = 'Заполните хотя бы 1 шаг приготовления';
        } else if (value.length > 5000) {
          newErrors.step1 = 'Максимальное значение 5000 знаков, Перенесите описание на след шаг';
        } else {
          const re = /^[А-Яа-я]/;
          newErrors.step1 = re.test(String(value).toLowerCase()) ? '' : 'Введите описание кириллицей';
        }
        break;

      case 'advice':
        if (value.length > 5000) {
          newErrors.advice = 'Максимальное значение 5000 знаков';
        } else {
          const re = /^[А-Яа-я]/;
          newErrors.advice = re.test(String(value).toLowerCase()) ? '' : 'Введите описание кириллицей';
        }
        break;

        case `weight${index}`:
        if (value < 0) { 
          newErrors[`weight${index}`] = 'Значение не может быть меньше 0'
        } else if (value === 0 ) {
          newErrors[`weight${index}`] = 'Значение не может быть равно 0';
        } else {
          newErrors[`weight${index}`] = ''
        } 
        break;
        case `step${index+1}`:
          if (value.length === 0) { 
            newErrors.step1 = 'Заполните хотя бы 1 шаг приготовления'
          } else if (value.length > 1000 ) {
            newErrors[`step${index+1}`] = 'Максимальное значение 1000 знаков, Перенесите описание на след шаг';
          } else {
            const re = /^[А-Яа-я]/;
            newErrors[`step${index+1}`]  = re.test(String(value).toLowerCase()) ? '' : 'Введите описание кириллицей';
          }
          break;
        case 'soak': case 'pickle': case 'cool': case 'infusion':  case 'freeze':
        if (value < 1) {
          newErrors[name] = 'Укажите время больше 5 мин или  удалите отметку';
        } else {
          newErrors[name]  = '';
        }
        break;
        case 'basic': 
        if (!checked) {
          newErrors[name] = 'Это поле обязательное для заполнения';
        } else if (value === 0 || value < 2) {
            newErrors[name] = 'Укажите время больше 2 мин';
        }  else {
          newErrors[name] = ''; // Очищаем ошибку, если все условия выполнены
        }
          break;
        case 'note':
          if(value === '') { 
            newErrors.note = ('Выберите способ обработки')
          }  else {
            newErrors.note = ('')
          }
        break;
        case 'type':
          newErrors.type = ('')
          
        break;
      default:
        break;
    }
    
    setError(newErrors);
  }; 
  return { error, validate, setError };
};

//Фильтр по поисковому слову в массиве
export function filtrSearchItem(arr, keyword) {
  const keywordSearch = keyword.toLowerCase();
  const NewArray = arr.filter((item) => {
    return item.toLowerCase().includes(keywordSearch)
  })
  return NewArray
}


export function sortCategory(arr) {
  let news = [...arr]
  return news.sort(function(a, b){
    return a.category === b.category ? 0 : a.category < b.category ? -1 : 1;
  })
}

export function sortName(arr) {
  let news = [...arr]
  return news.sort(function(a, b){
    return a.name === b.name ? 0 : a.name < b.name ? -1 : 1;
  })
}

export function sortArrDate(arr) {
  let newarr =[]
  for (let i = 0; i < arr.length; i++) {
    newarr.unshift(arr[i])
  }
  return newarr 
}

//Открытие и закрытие модальных окон
export function OpenModal(namevalues) {
  const [isOpen, setIsOpen] = useState(false)
  const [editData, setEditData] =useState(false)
  
  const handleOpen = () => {
    setIsOpen(true)
  };
  
  const handleClose = () => {
    setIsOpen(false)
    setEditData(false)
  };

  return { 
    isOpen, 
    setIsOpen,
    handleOpen,
    handleClose,
    editData,
    setEditData,
  }
}
  
//Изменение количества при клике + или -
export function Counter (cap) {

  const [capacity, setCapacity] = useState(cap.capacity)

  //счетчик членов семьи в плюс
    function handleCountClickPlus() {
      setCapacity(capacity+1) 
    }
  
    //счетчик членов семьи в минус
    function handleCountClickMinus() {
      if (capacity > 1) {
        setCapacity(capacity-1)
      }
    }
 
  return {
    capacity,
    handleCountClickPlus,
    handleCountClickMinus
  }
}